import { LeadInput } from './leadInput';

export class NewLeadInput {
  lead: LeadInput;
}
